import  { Service, ServiceStatusCode } from "../services/service-service";

interface ServiceDetailModalProps {
  rowName: string;
  data?: Service;
  loading: boolean;
  onClose: () => void;
}

const formatStatus = (status?: ServiceStatusCode): string => {
  switch (status) {
    case ServiceStatusCode.ACTIVE:
      return "Hoạt động";
    case ServiceStatusCode.INACTIVE:
      return "Ngưng hoạt động";
    case ServiceStatusCode.DELETED:
      return "deleted";
    default:
      return "inactive";
  }
};

export const ServiceDetailModal: React.FC<ServiceDetailModalProps> = ({
  rowName,
  data,
  loading,
  onClose,
}) => {
  const detailItems = [
    { label: "Tên dịch vụ", value: data?.name ?? rowName },
    { label: "Mã dịch vụ", value: data?.code ?? "-" },
    { label: "Đại lý", value: data?.branch_id !== undefined ? `Store #${data.branch_id}` : "-" },
    { label: "Trạng thái", value: formatStatus(data?.status) },
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 px-4">
      <div className="w-full max-w-xl rounded-3xl bg-white p-8 shadow-2xl">
        <div className="flex items-start justify-between">
          <h2 className="text-2xl font-semibold text-slate-800">Chi tiết dịch vụ</h2>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-8 w-8 items-center justify-center rounded-full text-xl text-slate-400 transition hover:bg-slate-100 hover:text-slate-600"
            aria-label="Close detail popup"
          >
            ×
          </button>
        </div>

        {loading ? (
          <div className="mt-10 flex justify-center">
            <span className="h-10 w-10 animate-spin rounded-full border-4 border-blue-500 border-t-transparent"></span>
          </div>
        ) : (
          <div className="mt-6 space-y-5">
            <dl className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {detailItems.map((item) => (
                <div key={item.label} className="rounded-xl bg-slate-50 p-4">
                  <dt className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                    {item.label}
                  </dt>
                  <dd className="mt-1 text-sm font-medium text-slate-800">{item.value}</dd>
                </div>
              ))}
            </dl>

            <div className="rounded-xl bg-slate-50 p-4">
              <h3 className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                Mô tả dịch vụ
              </h3>
              <p className="mt-2 text-sm text-slate-600">
                {data?.description ?? "Chưa có mô tả cho dịch vụ này."}
              </p>
            </div>

            <dl className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <div className="rounded-xl bg-slate-50 p-4">
                <dt className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                  Ngày tạo
                </dt>
                <dd className="mt-1 text-sm font-medium text-slate-800">
                  {data?.created_at ?? "-"}
                </dd>
              </div>
              <div className="rounded-xl bg-slate-50 p-4">
                <dt className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                  Ngày cập nhật
                </dt>
                <dd className="mt-1 text-sm font-medium text-slate-800">
                  {data?.updated_at ?? "-"}
                </dd>
              </div>
            </dl>
          </div>
        )}
      </div>
    </div>
  );
};

export default ServiceDetailModal;
